export const MIN_SSN_LENGTH = 8;

export const STEPS = {
  SSN: 'ssn',
  SYNC: 'sync',
};